var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.068,
    height: 18.364,
    viewBox: "969.659 45.5 15.068 18.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon material-notifications-none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.094 58.464v-4.709a6.903 6.903 0 0 0-.807-3.336 5.215 5.215 0 0 0-3.431-2.616v-.64a1.41 1.41 0 0 0-1.413-1.413 1.41 1.41 0 0 0-1.412 1.413v.64a5.448 5.448 0 0 0-4.085 4.412 7.607 7.607 0 0 0-.153 1.54v4.709l-1.884 1.883v.942h15.068v-.942l-1.883-1.883Zm-1.884.942h-7.534v-5.651c0-2.336 1.422-4.238 3.767-4.238a3.611 3.611 0 0 1 2.013.575c.84.552 1.407 1.459 1.638 2.536a5.378 5.378 0 0 1 .116 1.127v5.65Zm-1.883 2.825h-3.767a1.89 1.89 0 0 0 1.883 1.883 1.89 1.89 0 0 0 1.884-1.883Z",
    fill: "#5a6167",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.094 58.464v-4.709a6.903 6.903 0 0 0-.807-3.336 5.215 5.215 0 0 0-3.431-2.616v-.64a1.41 1.41 0 0 0-1.413-1.413 1.41 1.41 0 0 0-1.412 1.413v.64a5.448 5.448 0 0 0-4.085 4.412 7.607 7.607 0 0 0-.153 1.54v4.709l-1.884 1.883v.942h15.068v-.942l-1.883-1.883Zm-1.884.942h-7.534v-5.651c0-2.336 1.422-4.238 3.767-4.238a3.611 3.611 0 0 1 2.013.575c.84.552 1.407 1.459 1.638 2.536a5.378 5.378 0 0 1 .116 1.127v5.65Zm-1.883 2.825h-3.767a1.89 1.89 0 0 0 1.883 1.883 1.89 1.89 0 0 0 1.884-1.883Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#f6f7f9",
    fill: "transparent"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6c6818b01bfc8ccfc71e37f9f81eeecb.svg";
export { ForwardRef as ReactComponent };